import { LocalizationProvider, TimeField } from '@mui/x-date-pickers'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { forwardRef, RefObject } from 'react'

import { HandlerOf } from '../../helpers/typeHelper'
import { TextInput } from '../TextInput/TextInput'
const CustomInput = function CustomInput(props: any) {
  const { inputProps, InputProps, ownerState, inputRef, ...other } = props

  return (
    <div ref={InputProps?.ref}>
      <TextInput
        ref={inputRef}
        {...inputProps}
        {...(other as any)}
        noMargin
        placeholder={undefined}
        startAdornment={InputProps?.startAdornment}
      />
    </div>
  )
}

interface TimePickerProps {
  label?: string
  value?: any
  onChange?: HandlerOf<any>
  error?: React.ReactElement | string | boolean
  warning?: string | React.ReactElement
  onError?: HandlerOf<any>
  endAdornment?: React.ReactNode
  className?: string
}

export const TimePicker = forwardRef((props: TimePickerProps, ref) => {
  const { error, warning, className, ...pickerProps } = props

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <TimeField
        slots={{ textField: CustomInput }}
        slotProps={{
          textField: {
            ref: ref as RefObject<HTMLDivElement>,
            className,
            // @ts-ignore
            warning,
            error: error as any, // Our CustomInput needs string instead of boolean like material field
          },
        }}
        format="HH:mm"
        {...pickerProps}
      />
    </LocalizationProvider>
  )
})
